var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form record-picker-popup"
  }, [_c('div', {
    staticClass: "content-form-popup record-picker-content"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('modal-close-button', {
    attrs: {
      "aria-label": "Zavrieť príjmy"
    },
    on: {
      "click": _vm.closeDialog
    }
  }), _c('div', {
    staticClass: "_900 big"
  }, [_vm._v("Príjmy")])], 1), _vm.clientInfo ? _c('div', {
    staticClass: "header-block inline"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.clientInfo.type))]), _c('img', {
    staticClass: "image-10",
    attrs: {
      "src": _vm.getIcon(_vm.clientInfo.type),
      "loading": "lazy",
      "alt": ""
    }
  })]) : _vm._e(), _c('record-picker-tabs', {
    attrs: {
      "registered-count": _vm.incomesGetter.length,
      "aria-label": "Sekcie príjmov"
    },
    model: {
      value: _vm.activeSection,
      callback: function callback($$v) {
        _vm.activeSection = $$v;
      },
      expression: "activeSection"
    }
  }), _c('div', {
    staticClass: "w-form"
  }, [_c('div', {
    staticClass: "form-2",
    attrs: {
      "id": "email-form"
    }
  }, [_vm.activeSection === 'registered' ? _c('section', {
    staticClass: "picker-section"
  }, [_vm._m(0), _vm._l(_vm.incomesGetter, function (income) {
    return _c('div', {
      key: income.id,
      staticClass: "record-card",
      "class": {
        excluded: income.is_active === false
      }
    }, [_c('div', {
      staticClass: "record-main"
    }, [_c('div', {
      staticClass: "record-name"
    }, [income.zamestnavatel ? _c('span', [_vm._v(" " + _vm._s(income.zamestnavatel.name) + " "), _c('span', {
      staticClass: "record-type"
    }, [_vm._v("(" + _vm._s(_vm.translateIncomeType(income.druh)) + ")")])]) : _c('span', [_vm._v(_vm._s(_vm.translateIncomeType(income.druh)))])]), income.loading && _vm.togglingIncomeId !== income.id ? _c('v-progress-circular', {
      staticClass: "loading-spinner extrasmall",
      attrs: {
        "indeterminate": ""
      }
    }) : _c('div', {
      staticClass: "record-amount"
    }, [_vm._v(" +" + _vm._s(_vm._f("dotTheAmount")(_vm.incomeAmount(income))) + " EUR ")])], 1), income.error ? _c('div', {
      staticClass: "record-warning"
    }, [_vm._v(" Príjem treba dokončiť, aby sa dal správne vypočítať. ")]) : _vm._e(), _c('div', {
      staticClass: "record-actions"
    }, [_c('button', {
      staticClass: "record-edit",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.edit(income);
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "size": 17
      }
    }), _vm._v(" " + _vm._s(income.error ? "Dokončiť" : "Upraviť") + " ")], 1), _c('calculation-toggle', {
      attrs: {
        "value": income.is_active !== false,
        "busy": _vm.togglingIncomeId === income.id
      },
      on: {
        "change": function change($event) {
          return _vm.toggleIncome(income, $event);
        }
      }
    })], 1)]);
  }), _vm.incomesGetter.length === 0 ? _c('div', {
    staticClass: "empty-records"
  }, [_c('div', {
    staticClass: "empty-records-icon"
  }, [_c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 22
    }
  })], 1), _c('div', {
    staticClass: "empty-records-title"
  }, [_vm._v("Zatiaľ tu nie je žiadny príjem")]), _c('div', {
    staticClass: "empty-records-copy"
  }, [_vm._v("Pridajte prvý príjem klienta a aplikácia ho zahrnie do výpočtov.")]), _c('button', {
    staticClass: "empty-records-action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.activeSection = 'new';
      }
    }
  }, [_vm._v(" Pridať príjem ")])]) : _vm._e()], 2) : _c('section', {
    staticClass: "picker-section new-record-section"
  }, [_vm._m(1), _c('button', {
    staticClass: "option-block record-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.incomeTypePicker('trvaly_pracovny_pomer');
      }
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("zo zamestnania")]), _c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 19
    }
  })], 1), _c('button', {
    staticClass: "option-block record-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.incomeTypePicker('prijem_zivnostnika');
      }
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("zo živnosti")]), _c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 19
    }
  })], 1), _c('button', {
    staticClass: "option-block record-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.incomeTypePicker('prijem_z_sro');
      }
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("z podnikania SRO")]), _c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 19
    }
  })], 1), _vm._m(2), _c('button', {
    staticClass: "option-block record-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.incomeTypePicker('prijem_z_prenajmu_nehnutelnosti');
      }
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("príjem z prenájmu")]), _c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 19
    }
  })], 1), _c('button', {
    staticClass: "option-block record-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.incomeTypePicker('vysluhovy_dochodca');
      }
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("z dôchodku")]), _c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 19
    }
  })], 1), _c('button', {
    staticClass: "option-block record-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.incomeTypePicker('materska_rodicovsky_prispevok');
      }
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("rodičovský príspevok")]), _c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 19
    }
  })], 1)])])])], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-intro"
  }, [_c('div', {
    staticClass: "section-intro-title"
  }, [_vm._v("Evidované príjmy")]), _c('div', {
    staticClass: "section-intro-copy"
  }, [_vm._v(" Prepínač určuje, ktoré príjmy sa započítajú do limitov a bankových ponúk. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "splitter"
  }, [_vm._v(" 1. Vyberte typ "), _c('strong', [_vm._v("hlavného príjmu")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "splitter"
  }, [_vm._v(" 2. Vyberte typ "), _c('strong', [_vm._v("vedľajšieho príjmu")])]);

}]

export { render, staticRenderFns }